export default __webpack_public_path__ + "static/media/logo-sicc-es-br.a1b62320.png";